import { lazy, Suspense } from 'react';
import { AppVersionUpdater } from '@/components/app-version-updater/app-version-updater';
import { TermsAcceptance } from '@/components/terms-acceptance/terms-acceptance';
import { useRedesign } from '@/feature-flags/redesign/use-redesign.ts';
import { NotificationsSubscription } from '@/routes/_app.p.notifications._index/notifications-subscription';
import { usePullToRefreshIos } from '@/utils/use-pull-to-refresh-ios.tsx';
import { useReadPushNotifications } from '@/utils/use-read-push-notifications.ts';
import AppShellV2 from './app-shell-v2/app-shell-v2.tsx';
import { BootIntercom } from './boot-intercom';
import { CustomCollectionsChangedSubscription } from './custom-collections-changed-subscription';
import { useAppLoader } from './loader';
import { NotificationFaviconUpdater } from './notification-favicon-updater';
import { SplashScreen } from './splash-screen';
import { useFpsHandshake } from './use-fps-handshake';

const AppShellV1 = lazy(() => import('./app-shell-v1.tsx'));

const AuthenticatedBehaviours = () => {
  usePullToRefreshIos();
  useReadPushNotifications();
  useFpsHandshake();

  return (
    <>
      <NotificationsSubscription />
      <CustomCollectionsChangedSubscription />
      <Suspense fallback={null}>
        <NotificationFaviconUpdater />
      </Suspense>
      <Suspense fallback={null}>
        <TermsAcceptance />
      </Suspense>
    </>
  );
};

const AppBehaviours = () => {
  const { authenticated } = useAppLoader();

  return (
    <>
      {authenticated ? <AuthenticatedBehaviours /> : null}
      <BootIntercom />
      <AppVersionUpdater />
    </>
  );
};

export const AppContent = () => {
  const redesign = useRedesign();

  if (redesign) {
    return (
      <AppShellV2>
        <AppBehaviours />
      </AppShellV2>
    );
  }

  return (
    <Suspense fallback={<SplashScreen />}>
      <AppShellV1>
        <AppBehaviours />
      </AppShellV1>
    </Suspense>
  );
};
